import { createDynamicSlice } from ".";
import { getCurrencyListThunk } from "../thunks/currenciesThunk";

export const currenciesSlice = createDynamicSlice({
  name: "currencies",
  thunk: getCurrencyListThunk,
  listMode: true,
  resetActionName: "resetCurrencies",
});

export const currenciesReducer = currenciesSlice.reducer;
export const { resetCurrencies } = currenciesSlice.actions;
